import { EventBus, Events } from "jiffy-store";
import madeStore from "components/jiffy/vue-product-details-print/store/store";
import "./pdp-experience-warning.scss";

const DISABLED_CLASS_NAME = "product-details-variants-form__grid-wrapper--disabled";
const HIDDEN_CLASS_NAME = "hidden";

const $getDeliveryDates = () =>
  document.getElementById("js-made-product-details-delivery-dates-simple-container");
const $getActiveComposition = () => document.querySelector(".js-color-variant-selector-active");
const $getProductGrid = () => document.getElementById("js-product-mobile-grid");
const $getWarning = () => document.querySelector(".js-pdp-experience-warning");

const checkSupportsMade = mode => {
  const { supportsMade } = $getActiveComposition()?.dataset || {};
  const isHidden = supportsMade === "false";
  madeStore.commit("app/setSupportsMade", !isHidden);
  if (mode === "made") {
    $getProductGrid()?.classList?.toggle(DISABLED_CLASS_NAME, isHidden);
    $getWarning()?.classList?.toggle(HIDDEN_CLASS_NAME, !isHidden);
  } else {
    $getProductGrid()?.classList?.remove(DISABLED_CLASS_NAME);
    $getWarning()?.classList?.add(HIDDEN_CLASS_NAME);
  }

  $getDeliveryDates()?.classList?.toggle(HIDDEN_CLASS_NAME, isHidden);
};

const init = () => {
  madeStore.watch(state => state.app.mode, checkSupportsMade, { immediate: true });

  EventBus.on(Events.PRODUCT_COLOR_SELECTED_FROM_SLIDER, () => {
    const mode = madeStore?.getters?.["app/mode"];
    checkSupportsMade(mode);
  });
};

export default init;
